<app-form-modal
  [title]="isEditMode ? 'ADMIN.MAIL_ACCOUNTS.EDIT_TITLE' : 'ADMIN.MAIL_ACCOUNTS.CREATE_TITLE'"
  [loading]="loading"
  [formGroup]="form"
  [errorMessage]="errorMessage"
  [closeText]="'CANCEL'"
  [submitText]="'SAVE'"
  (submitClicked)="save()">
  <div class="row g-2">
      <div class="col-12">
        <h6 class="text-muted">{{ 'ADMIN.MAIL_ACCOUNTS.SECTION_CONNECTION' | translate }}</h6>
      </div>
      <div class="col-md-6">
        <app-form-input
          id="create-mail-host"
          label="ADMIN.MAIL_ACCOUNTS.HOST"
          controlName="host"
          [formGroup]="form"
          [isRequired]="true" />
                @for (error of getErrors('host'); track error) {
          <app-validation-error [text]="error" />
        }
      </div>
      <div class="col-md-3"
           [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.PORT_TOOLTIP' | translate"
           placement="top"
           trigger="hover">
        <app-form-input
          id="create-mail-port"
          label="ADMIN.MAIL_ACCOUNTS.PORT"
          controlName="port"
          [formGroup]="form"
          type="number"
          [isRequired]="true" />
      </div>
      <div class="col-md-3"
           [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.SSL_TOOLTIP' | translate"
           placement="top"
           trigger="hover">
        <app-checkbox-input
          id="create-mail-ssl"
          label="ADMIN.MAIL_ACCOUNTS.SSL"
          controlName="ssl"
          [formGroup]="form" />
      </div>
      <div class="col-md-6">
        <app-form-input
          id="create-mail-username"
          label="ADMIN.MAIL_ACCOUNTS.USERNAME"
          controlName="username"
          [formGroup]="form"
          [isRequired]="true" />
                @for (error of getErrors('username'); track error) {
          <app-validation-error [text]="error" />
        }
      </div>
      <div class="col-md-6"
           [mdbTooltip]="isEditMode ? ('ADMIN.MAIL_ACCOUNTS.PASSWORD_LEAVE_BLANK' | translate) : ''"
           placement="top"
           trigger="hover">
        <app-form-input
          id="create-mail-password"
          label="ADMIN.MAIL_ACCOUNTS.PASSWORD"
          controlName="password"
          [formGroup]="form"
          type="password" />
      </div>
      <div class="col-12"
           [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.REMOTE_FOLDER_TOOLTIP' | translate"
           placement="top"
           trigger="hover">
        <label class="form-label">
          {{ 'ADMIN.MAIL_ACCOUNTS.REMOTE_FOLDER' | translate }}
        </label>
        <app-form-input
          id="create-mail-remote-folder"
          label="ADMIN.MAIL_ACCOUNTS.REMOTE_FOLDER"
          controlName="remoteFolder"
          [formGroup]="form"
          [isRequired]="true"
          [hideLabel]="true"
          [disabled]="allFolders()" />
        <div class="form-check mt-1">
          <input
            type="checkbox"
            class="form-check-input"
            id="create-mail-all-folders"
            [checked]="allFolders()"
            (change)="setAllFolders(!allFolders())" />
          <label class="form-check-label" for="create-mail-all-folders">
            {{ 'ADMIN.MAIL_ACCOUNTS.ALL_FOLDERS' | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <div class="col-12">
        <h6 class="text-muted">{{ 'ADMIN.MAIL_ACCOUNTS.SECTION_GENERAL' | translate }}</h6>
      </div>
      <div class="col-md-6">
        <app-form-input
          id="create-mail-name"
          label="ADMIN.MAIL_ACCOUNTS.NAME"
          controlName="name"
          [formGroup]="form"
          [isRequired]="true" />
      </div>
      <div class="col-md-6"
           [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.OWNER_TOOLTIP' | translate"
           placement="top"
           trigger="hover">
        <app-form-select
          id="create-mail-owner"
          [formGroup]="form"
          controlName="userId"
          [label]="'ADMIN.MAIL_ACCOUNTS.OWNER'"
          [placeholder]="'ADMIN.MAIL_ACCOUNTS.SELECT_OWNER'"
          [options]="users"
          [optionLabelSelector]="[{ selector: 'username' }]"
          optionValueSelector="id"
          [clear]="false"
        />
      </div>
    </div>

    <div class="row g-2">
      <div class="col-12">
        <h6 class="text-muted">{{ 'ADMIN.MAIL_ACCOUNTS.SECTION_OPTIONS' | translate }}</h6>
      </div>
      <div class="col-md-4">
        <app-checkbox-input
          id="create-mail-active"
          label="ADMIN.MAIL_ACCOUNTS.ACTIVE"
          controlName="active"
          [formGroup]="form" />
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center gap-2 mb-2">
          <button type="button" class="btn btn-link p-0 text-muted" (click)="toggleAdvanced()">
            {{ 'ADMIN.MAIL_ACCOUNTS.SECTION_ADVANCED' | translate }}
            <i class="fas" [class.fa-chevron-down]="!advancedExpanded()" [class.fa-chevron-up]="advancedExpanded()"></i>
          </button>
        </div>
        @if (advancedExpanded()) {
          <div class="advanced-section">
          <div class="row g-2">
            <div class="col-md-4"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.SINCE_DAYS_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-form-input
                id="create-mail-since-days"
                label="ADMIN.MAIL_ACCOUNTS.SINCE_DAYS"
                controlName="sinceDays"
                [formGroup]="form"
                type="number"
                [min]="0" />
            </div>
            <div class="col-md-4"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.SINCE_MINUTES_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-form-input
                id="create-mail-since-minutes"
                label="ADMIN.MAIL_ACCOUNTS.SINCE_MINUTES"
                controlName="sinceMinutes"
                [formGroup]="form"
                type="number"
                [min]="0" />
            </div>
            <div class="col-md-6"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.BODY_SEARCHABLE_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-checkbox-input
                id="create-mail-body-searchable"
                label="ADMIN.MAIL_ACCOUNTS.BODY_SEARCHABLE"
                controlName="bodySearchable"
                [formGroup]="form" />
            </div>
            <div class="col-md-6"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.PDF_SEARCHABLE_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-checkbox-input
                id="create-mail-pdf-searchable"
                label="ADMIN.MAIL_ACCOUNTS.PDF_SEARCHABLE"
                controlName="pdfSearchable"
                [formGroup]="form" />
            </div>
            <div class="col-md-6"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.EML_GZ_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-checkbox-input
                id="create-mail-eml-gz"
                label="ADMIN.MAIL_ACCOUNTS.EML_GZ"
                controlName="emlGz"
                [formGroup]="form" />
            </div>
            <div class="col-md-6"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.JSON_GZ_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-checkbox-input
                id="create-mail-json-gz"
                label="ADMIN.MAIL_ACCOUNTS.JSON_GZ"
                controlName="jsonGz"
                [formGroup]="form" />
            </div>
            <div class="col-12"
                 [mdbTooltip]="'ADMIN.MAIL_ACCOUNTS.TRASHMODE_TOOLTIP' | translate"
                 placement="top"
                 trigger="hover">
              <app-enum-select
                [formGroup]="form"
                controlName="trashmode"
                [enum]="trashmodeOptions"
                [label]="'ADMIN.MAIL_ACCOUNTS.TRASHMODE'"
                [castFunction]="trashmodeLabelKey"
              />
            </div>
          </div>
          </div>
        }
      </div>
    </div>

    <div class="row g-2">
      <div class="col-12">
        <h6 class="text-muted">{{ 'ADMIN.MAIL_ACCOUNTS.SECTION_ASSIGNMENTS' | translate }}</h6>
      </div>
      <div class="col-12">
        <app-form-select
          id="assigned-users"
          [formGroup]="form"
          controlName="assignedUserIds"
          [label]="'ADMIN.MAIL_ACCOUNTS.ASSIGNED_USERS_LABEL'"
          [placeholder]="'ADMIN.MAIL_ACCOUNTS.SECTION_ASSIGNMENTS'"
          [options]="filteredUserOptions()"
          [optionLabelSelector]="[{ selector: 'username' }]"
          optionValueSelector="id"
          [filter]="true"
          [multiple]="true"
          [clear]="true"
          (search)="onAssignedUsersSearch($event)"
          (opened)="onAssignedUsersOpened()"
        />
      </div>
    </div>
</app-form-modal>
